import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ThesesStats } from 'app/dialogs';

// panel with small bar diagram
@Component({
  selector: 'theses-pane-2',
  templateUrl: 'theses-pane-2.html',
  styleUrls: ['theses-pane-2.scss'],
})
export class ThesesPane2 {

  @Input() public title: string;

  @Input() public label: string;

  @Input() public data: Array<ThesesStats>;

  @Output() public interactionClicked: EventEmitter<void> = new EventEmitter<void>();

  public onInteractionClicked(event: Event): void {
    event.stopPropagation();
    this.interactionClicked.emit();
  }

}
